<script>
import VehicleListingsBase from "@/components/VehicleListings/VehicleListingsBase.vue";

export default {
  name: "VehicleListingsCustom",
  extends: VehicleListingsBase
};
</script>
